module.exports = __webpack_public_path__ + "img/symbol_6.cf8da459.png";